module.exports = __webpack_public_path__ + "static/media/customer-service.dc8471bd.svg";